import gql from 'graphql-tag';

export const PLAN_DETECTION_RUN_FIELDS = gql`
	fragment PlanDetectionRunFields on PlanDetectionRun {
		runId
		planItemId
		stage
		status
		failureReason
		processed
		total
	}
`;
